import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CommonmodelService {
  subject= new BehaviorSubject('modal-xl');
  constructor() { 
    // alert(this.subject)
 /*    console.log(this.subject) */
  }
}
